import { globalProps } from '@/api/Global';
import Cookies from 'js-cookie';

const KEY = 'IDMESH_LNG';
const langs = ['zh', 'en'] as const;
export type LANGS = typeof langs[number] | '';

interface LangRef {
  value: LANGS;
}

const getDefaultLang = function () {
  const langLs = localStorage.getItem(KEY);
  let lang = Cookies.get(KEY) as LANGS;
  if (!lang && langLs) {
    Cookies.set(KEY, lang, {
      domain: `.${globalProps.MainDomain}`,
      expires: 365,
    });
  }
  lang = Cookies.get(KEY) as LANGS;
  if (lang && langs.includes(lang)) return lang as LANGS;
  return '';
}
export const getSysLang = function () {
  if (window.navigator.language?.includes('en')) return 'en';
  if (window.navigator.language?.includes('zh')) return 'zh';
  if (window.navigator.languages) {
    let lng = '';
    for (const l of window.navigator.languages) {
      if (l?.includes('en')) {
        lng = 'en';
        break;
      } else if (l?.includes('zh')) {
        lng = 'zh';
        break;
      } 
    }
    if (lng) return lng as 'zh' | 'en';
  }
  return 'zh';
};

export const changeLangAndSave = (lang: LANGS, save = false): void => {
  langRef.value = lang;
  if (save) {
    localStorage.setItem(KEY, lang);
    Cookies.set(KEY, lang, {
      domain: `.${globalProps.MainDomain}`,
      expires: 365,
    });
  }
}

export const langRef: LangRef = {
  value: getDefaultLang(),
};
